import { apiClient } from '@/api/axios';

const ISO_DATE_LENGTH = 10;

export function getFileDateStamp(): string {
  return new Date().toISOString().slice(0, ISO_DATE_LENGTH);
}

/** Hands a Blob to the browser as a file download. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked on the next tick: some browsers start the download asynchronously.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export { saveBlob as downloadBlob };

const BLOB_RELEASE_DELAY_MS = 60_000;

export function openBlobInNewTab(blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const opened = window.open(url, '_blank', 'noopener,noreferrer');

  if (opened === null) {
    saveBlob(blob, 'DCR-TopSheet.html');
    URL.revokeObjectURL(url);
    return;
  }

  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, BLOB_RELEASE_DELAY_MS);
}

/**
 * Downloads an API file. The filename is the caller's: the API's
 * Content-Disposition is not readable cross-origin.
 */
export async function downloadApiFile(
  url: string,
  filename: string,
  params?: Record<string, unknown>,
): Promise<void> {
  const res = await apiClient.get<Blob>(url, { responseType: 'blob', params });
  saveBlob(res.data, filename);
}
